/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-privilege-dropdown .content-body{width:215px}app-privilege-dropdown .hide-check li.ui-state-disabled.ui-multiselect-item>div.ui-chkbox{display:none!important}"];
export { styles as styles };
